import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {GeneralModule} from "../general/general.module";
import {SalesCreditSummaryKredicashComponent} from "./kredicash/sales-credit-summary-kredicash.component";
import {SalesCreditSummaryKredicashV2Component, SalesCreditSummaryKredicashV3Component} from "./kredicash/versions/sales-credit-summary-kredicash-versions.component";
import {SalesCreditSummaryGeneralComponent} from "./general/sales-credit-summary-general.component";
import {ReactiveFormsModule} from "@angular/forms";
import {SalesCreditSummaryComponent} from "./sales-credit-summary.component";
import {SalesSimulatorModule} from "../simulator/sales-simulator.module";
import {SalesCreditSummaryExpressComponent} from "./express/sales-credit-summary-express.component";



@NgModule({
  declarations: [
    SalesCreditSummaryKredicashComponent,
    SalesCreditSummaryKredicashV2Component,
    SalesCreditSummaryKredicashV3Component,
    SalesCreditSummaryGeneralComponent,
    SalesCreditSummaryComponent,
    SalesCreditSummaryExpressComponent,
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    GeneralModule,
    ReactiveFormsModule,
    SalesSimulatorModule,
  ],
  exports: [
    SalesCreditSummaryComponent
  ]
})
export class SalesCreditSummaryModule { }
